/* Mitsi & Co cart drawer. AJAX add-to-cart against Shopify's cart API, line edits (size, colour,
   quantity), and the matching-leash and add-another-vest nudges. Config arrives via
   window.NPDrawerData (set in theme.liquid). Booties, Walk Kit and the preview demo cart removed 2026-10-30. */
(function () {
  var D = window.NPDrawerData || {};
  var lastFocus = null;
  var uncertain = false;
  var checkoutStarted = false;
  var cartDirty = false;

  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function shortTitle(handle, fallback) { return (D.titles && D.titles[handle]) || fallback; }
  function escapeHtml(value) { var span = document.createElement('span'); span.textContent = value || ''; return span.innerHTML.replace(/"/g, '&quot;'); }

  function api(path, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + path.replace(/^\//, ''), {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      // Shopify answers rate limits (429) and outages with an HTML page; never show a JSON parse error.
      if ((r.headers.get('content-type') || '').indexOf('text/html') !== -1) {
        var busy = new Error(r.status === 429 ? 'The store is busy. Wait a few seconds and try again.' : 'We could not reach your cart. Please try again.');
        if (r.status === 429) busy.confirmedFailure = true;
        throw busy;
      }
      return r.json().then(function (data) {
        if (!r.ok) { var error = new Error(data.description || 'We could not update your cart. Please try again.'); error.confirmedFailure = true; throw error; }
        return data;
      });
    });
  }

  function el(id) { return document.getElementById(id); }

  // Dog's name (2026-10-26): optional cart attribute "Dog name" -> order note attributes, for personalised order emails.
  var savedDogName = null;
  function dogNameValue() {
    var fields = Array.from(document.querySelectorAll('[data-dog-name]'));
    var active = fields.find(function (f) { return f === document.activeElement; });
    var filled = fields.find(function (f) { return f.value.trim(); });
    return ((active || filled || {}).value || '').trim().slice(0, 40);
  }
  function syncDogName(value) {
    document.querySelectorAll('[data-dog-name]').forEach(function (f) { if (f !== document.activeElement) f.value = value; var d = f.closest('details'); if (value && d) d.open = true; });
  }
  function saveDogName() {
    var value = dogNameValue();
    if (savedDogName === null || value === savedDogName) return Promise.resolve();
    return api('/cart/update.js', { attributes: { 'Dog name': value } }).then(function () { savedDogName = value; syncDogName(value); }).catch(function () {});
  }

  function open() {
    lastFocus = document.activeElement;
    el('np-drawer').classList.add('open');
    el('np-scrim').classList.add('open');
    el('np-drawer').inert = false;
    document.body.style.overflow = 'hidden';
    el('npd-close').focus();
  }
  function close() {
    el('np-drawer').classList.remove('open');
    el('np-scrim').classList.remove('open');
    el('np-drawer').inert = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    if (cartDirty && document.body.classList.contains('template-cart')) window.location.reload();
  }

  function lineHtml(img, title, meta, priceHtml, controls) {
    return '<div class="npd-line">' +
      (img ? '<img src="' + escapeHtml(img) + '" alt="">' : '') +
      '<div><div class="t">' + escapeHtml(title) + '</div><div class="m">' + escapeHtml(meta) + '</div>' + (controls || '') + '</div>' +
      '<div class="p">' + priceHtml + '</div></div>';
  }

  function render(cart) {
    var saving = 0, html = '';
    cart.items.forEach(function (i) {
      if (i.original_line_price > i.final_line_price) saving += i.original_line_price - i.final_line_price;
      html += lineHtml((window.MitsiVariantImages || {})[i.variant_id] || i.image, shortTitle(i.handle, i.product_title),
        (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + (i.quantity > 1 ? ' · ×' + i.quantity : ''),
        fmt(i.original_line_price), lineControls(i));
    });
    if (saving) html += '<div class="npd-line npd-saving-line"><div><div class="t">Savings</div><div class="m">Applied automatically</div></div><div class="p">−' + fmt(saving) + '</div></div>';
    savedDogName = (cart.attributes && cart.attributes['Dog name']) || '';
    syncDogName(savedDogName);

    el('npd-items').innerHTML = html || '<div class="npd-empty">Your cart is empty.</div>';
    el('npd-count').textContent = cart.item_count;
    el('npd-subtotal').textContent = fmt(cart.total_price);
    document.querySelectorAll('.nav-cart').forEach(function (n) { n.textContent = 'Cart (' + cart.item_count + ')'; });

    var vestLine = cart.items.find(function (i) { return i.handle === D.vestHandle; });
    showPairNudge(vestLine ? vestLine.variant_id : null);
    showLeashNudge(cart.items.map(function (i) { return { handle: i.handle, meta: i.variant_title || '' }; }));
    // Free US shipping on every order (2026-10-29).
    el('npd-ship-msg').innerHTML = '<strong>✓ Free US shipping on every order</strong>';
    el('npd-bar-fill').style.width = '100%';

    var co = el('npd-checkout');
    if (!cart.item_count) { co.setAttribute('aria-disabled', 'true'); co.textContent = 'Your cart is empty'; co.removeAttribute('href'); }
    else { co.removeAttribute('aria-disabled'); co.textContent = 'Checkout'; co.href = '/checkout'; }
  }

  function refresh() {
    if (el('npd-error')) el('npd-error').hidden = true;
    return api('/cart.js').then(render);
  }

  function addItems(items, metas, intent) {
    if (uncertain) return Promise.reject(new Error('Check your cart before adding again. The previous update could not be confirmed.'));
    var submitted = false;
    var before;
    function count(cart, id) { return cart.items.filter(function (i) { return i.variant_id === id; }).reduce(function (n, i) { return n + i.quantity; }, 0); }
    return api('/cart.js').then(function (cart) {
      before = cart;
      submitted = true;
      return api('/cart/add.js', { items: items });
    }).then(function () {
      var name = dogNameValue();
      if (name && name !== (before.attributes && before.attributes['Dog name'])) return api('/cart/update.js', { attributes: { 'Dog name': name } }).catch(function () {});
    }).then(function () { return api('/cart.js'); }).then(function (cart) {
      if (!items.every(function (item) { return count(cart, item.id) >= count(before, item.id) + item.quantity; })) {
        throw new Error('Your full selection could not be confirmed. Review your cart before continuing.');
      }
      render(cart);
      if (intent === 'checkout') { checkoutStarted = true; window.location.assign('/checkout'); return; }
      open();
    }).catch(function (error) {
      if (submitted) {
        uncertain = true;
        return api('/cart.js').then(function (cart) { render(cart); open(); }).catch(function () { open(); }).then(function () {
          throw new Error((error.confirmedFailure ? error.message + ' ' : '') + 'Check the items in your cart before continuing. The update could not be confirmed; it has not been retried.');
        });
      }
      throw error;
    });
  }

  // Size/colour edit in the drawer for products sold in sizes (vest, raincoat); the leash only takes quantity.
  function allowedVariants(item) {
    return ((D.editVariants || {})[item.handle] || []).filter(function (v) { return v.available; });
  }
  function lineControls(item) {
    var variants = allowedVariants(item), edit = '';
    if (variants.length) {
      edit = '<details class="npd-edit"><summary>Edit</summary><label>Size and color<select data-edit-key="' + escapeHtml(item.key) + '" data-old-id="' + item.variant_id + '" data-qty="' + item.quantity + '" data-properties="' + escapeHtml(JSON.stringify(item.properties || {})) + '">';
      variants.forEach(function (v) { edit += '<option value="' + v.id + '"' + (v.id === item.variant_id ? ' selected' : '') + '>' + escapeHtml(v.color + ' / ' + v.size) + '</option>'; });
      edit += '</select></label><label>Quantity<input data-edit-qty type="number" min="1" value="' + item.quantity + '"></label><button type="button" class="npd-save-edit">Save</button></details>';
    }
    return qtyStepper('data-qty-key="' + escapeHtml(item.key) + '"', item.quantity) + edit + '<button class="rm" data-key="' + escapeHtml(item.key) + '">Remove</button>';
  }
  // Quantity stepper (max, 2026-10-30): no two-vests button on the page, so more vests go in here.
  function qtyStepper(attr, qty) {
    return '<span class="npd-qty"><button type="button" ' + attr + ' data-step="-1" aria-label="One fewer"' + (qty <= 1 ? ' disabled' : '') + '>−</button>' +
      '<span aria-live="polite">' + qty + '</span><button type="button" ' + attr + ' data-step="1" aria-label="One more">+</button></span>';
  }

  function swapLine(details) {
    cartDirty = true;
    var select = details.querySelector('select[data-edit-key]'), qty = parseInt(details.querySelector('[data-edit-qty]').value, 10);
    var oldKey = select.dataset.editKey, oldId = parseInt(select.dataset.oldId, 10), newId = parseInt(select.value, 10), properties = {};
    try { properties = JSON.parse(select.dataset.properties || '{}'); } catch (e) {}
    if (!qty || qty < 1) return Promise.reject(new Error('Choose a quantity of at least 1.'));
    if (newId === oldId) return api('/cart/change.js', { id: oldKey, quantity: qty }).then(refresh);
    var replacementAdded = false, original;
    function sameProperties(a, b) { var keys = Object.keys(a || {}).sort(); return JSON.stringify(keys.map(function (k) { return [k, a[k]]; })) === JSON.stringify(Object.keys(b || {}).sort().map(function (k) { return [k, b[k]]; })); }
    return api('/cart.js').then(function (cart) {
      original = cart.items.find(function (i) { return i.key === oldKey; });
      if (!original) throw new Error('This cart item changed. Close and reopen your cart, then try again.');
      var item = { id: newId, quantity: qty, properties: original.properties || {} };
      if (original.selling_plan_allocation) item.selling_plan = original.selling_plan_allocation.selling_plan.id;
      return api('/cart/add.js', { items: [item] });
    }).then(function () {
      replacementAdded = true;
      return api('/cart.js').then(function (cart) {
        var candidates = cart.items.filter(function (i) { return i.variant_id === oldId && sameProperties(i.properties, original.properties) && JSON.stringify(i.selling_plan_allocation || null) === JSON.stringify(original.selling_plan_allocation || null); });
        var stale = cart.items.find(function (i) { return i.key === oldKey; }) || (candidates.length === 1 ? candidates[0] : null);
        var added = cart.items.find(function (i) { return i.variant_id === newId && sameProperties(i.properties, original.properties); });
        if (!added || !stale) throw new Error('The new choice was added, but the old line changed. Review your cart before checkout; nothing was removed.');
        return api('/cart/change.js', { id: stale.key, quantity: 0 }).catch(function () {
          throw new Error('The new choice was added, but the old one could not be removed. Review both lines before checkout.');
        });
      });
    }).then(refresh).catch(function (error) {
      if (!replacementAdded) throw error;
      var message = error.message.indexOf('new choice was added') !== -1 ? error.message : 'The new choice was added, but the cart could not be verified. Review your cart before trying again.';
      return refresh().catch(function () {}).then(function () { throw new Error(message); });
    });
  }

  var pairPick = { color: '', size: '', from: null };
  function syncPairPills() {
    var box = el('npd-pair');
    if (!box) return;
    box.querySelectorAll('[data-pg]').forEach(function (p) {
      var g = p.dataset.pg, val = p.dataset.v;
      var probe = g === 'size' ? { color: pairPick.color, size: val } : { color: val, size: pairPick.size };
      var ok = (D.vestVariants || []).some(function (x) { return x.available && x.color === probe.color && (!probe.size || x.size === probe.size); });
      p.disabled = !ok;
      p.classList.toggle('on', pairPick[g] === val);
      p.setAttribute('aria-pressed', String(pairPick[g] === val));
    });
    var v = (D.vestVariants || []).find(function (x) { return x.color === pairPick.color && x.size === pairPick.size; });
    var add = el('npd-pair-add');
    if (add) add.disabled = !v || !v.available;
  }
  function showPairNudge(vestVariantId) {
    var box = el('npd-pair');
    if (!box) return;
    box.hidden = !vestVariantId;
    if (!vestVariantId) return;
    var first = (D.vestVariants || []).find(function (x) { return x.id === vestVariantId; });
    if (first && pairPick.from !== vestVariantId) {
      pairPick.color = first.color; pairPick.size = first.size; pairPick.from = vestVariantId;
    }
    el('npd-pair-total').textContent = 'Pick a color and size. Shipping stays free.';
    syncPairPills();
  }

  // Matching leash (2026-10-30): offered when a vest or raincoat is in the cart and no leash is.
  // The colour follows the most recently listed vest/raincoat line, as on the product pages.
  var leashPick = null;
  function showLeashNudge(lines) {
    var box = el('npd-leash');
    if (!box) return;
    leashPick = null;
    var hasLeash = lines.some(function (l) { return l.handle === D.leashHandle; });
    var item = lines.filter(function (l) { return D.leashMatch && D.leashMatch[l.handle]; }).pop();
    if (!hasLeash && item) {
      var leashColor = D.leashMatch[item.handle][(item.meta.split(' / ')[0] || '').trim()];
      leashPick = (D.leashVariants || []).find(function (v) { return v.color === leashColor && v.available; }) || null;
    }
    box.hidden = !leashPick;
    if (!leashPick) return;
    el('npd-leash-sub').textContent = 'Reflective · 6 ft · ' + leashPick.color + ' to match';
    el('npd-leash-pic').src = leashPick.img; el('npd-leash-pic').alt = leashPick.color + ' reflective leash';
    el('npd-leash-add').textContent = 'Add · ' + fmt(leashPick.cents).replace('.00', '');
  }

  function removeKey(key) {
    cartDirty = true;
    api('/cart/change.js', { id: key, quantity: 0 }).then(refresh).catch(showError);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!el('np-drawer')) return;

    el('np-scrim').addEventListener('click', close);
    el('npd-close').addEventListener('click', close);

    document.querySelectorAll('[data-dog-name]').forEach(function (field) {
      field.addEventListener('input', function () { document.querySelectorAll('[data-dog-name]').forEach(function (f) { if (f !== field) f.value = field.value; }); });
    });
    if (el('npd-dog-name')) el('npd-dog-name').addEventListener('change', saveDogName);
    el('npd-checkout').addEventListener('click', function (e) {
      if (savedDogName === null || dogNameValue() === savedDogName || !el('npd-checkout').getAttribute('href')) return;
      e.preventDefault();
      var href = el('npd-checkout').href;
      saveDogName().then(function () { window.location.assign(href); });
    });
    document.addEventListener('keydown', function (e) {
      if (el('fit-dialog') && el('fit-dialog').open) return;
      if (!el('np-drawer').classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var focusable = Array.from(el('np-drawer').querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])')).filter(function (x) { return x.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    document.querySelectorAll('.nav-cart').forEach(function (n) {
      n.addEventListener('click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        refresh().then(open).catch(function (error) { open(); showError(error); });
      });
    });

    document.querySelectorAll('[data-cart-edit-key]').forEach(function (button) {
      button.addEventListener('click', function () {
        refresh().then(function () {
          open();
          var select = Array.from(el('npd-items').querySelectorAll('[data-edit-key]')).find(function (x) { return x.dataset.editKey === button.dataset.cartEditKey; });
          if (select) { select.closest('details').open = true; select.focus(); }
          else showError(new Error('This legacy item can be removed here, but its current options are no longer offered.'));
        }).catch(showError);
      });
    });

    el('npd-items').addEventListener('click', function (e) {
      var save = e.target.closest('.npd-save-edit');
      if (save) {
        if (save.disabled) return;
        save.disabled = true; save.textContent = 'Saving…';
        swapLine(save.closest('.npd-edit')).catch(showError).finally(function () { save.disabled = false; save.textContent = 'Save'; });
        return;
      }
      var step = e.target.closest('[data-step]');
      if (step) {
        if (step.disabled) return;
        var by = parseInt(step.dataset.step, 10);
        if (step.dataset.qtyKey) {
          var now = parseInt(step.parentNode.querySelector('span').textContent, 10) || 1;
          step.disabled = true; cartDirty = true;
          api('/cart/change.js', { id: step.dataset.qtyKey, quantity: Math.max(1, now + by) }).then(refresh).catch(showError);
        }
        return;
      }
      var rm = e.target.closest('.rm');
      if (!rm) return;
      if (rm.dataset.key) removeKey(rm.dataset.key);
    });

    // product form intercept
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (document.body.classList.contains('template-cart')) return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = parseInt(f.querySelector('[name="id"]').value, 10);
        var items = [{ id: vid, quantity: 1 }];
        var metas = [collectPageMeta(f)];
        if (f.dataset.busy === 'true' || checkoutStarted) return;
        if (window.NPKit && !window.NPKit.valid) { showError(new Error('Please choose an available color and size for each item.')); return; }
        if (window.NPKit && window.NPKit.extra) {
          window.NPKit.extra.forEach(function (x) {
            var same = items.find(function (it) { return it.id === x.id; });
            if (same) same.quantity += 1;
            else { items.push({ id: x.id, quantity: 1 }); metas.push(x.meta); }
          });
        }
        var button = f.querySelector('[type="submit"]'), label = button.textContent;
        var controls = Array.from(f.querySelectorAll('button,input,select')).concat(el('sa-btn') ? [el('sa-btn')] : []);
        var states = controls.map(function (control) { return control.disabled; });
        f.dataset.busy = 'true'; controls.forEach(function (control) { control.disabled = true; }); button.textContent = 'Adding…';
        if (el('purchase-error')) el('purchase-error').hidden = true;
        var intent = f.dataset.intent === 'checkout' ? 'checkout' : 'cart';
        f.dataset.intent = '';
        var added = false;
        addItems(items, metas, intent).then(function () { added = true; }).catch(showError).finally(function () { if (!checkoutStarted) { f.dataset.busy = 'false'; controls.forEach(function (control, index) { control.disabled = states[index]; }); button.textContent = added ? 'Added ✓' : label; if (added) { button.classList.add('v5-added'); setTimeout(function () { button.textContent = label; button.classList.remove('v5-added'); }, 1800); } } });
      });
    });

    // second vest one-tap inside the drawer (2026-10-28): starts on the first vest's colour and size
    var pairAdd = el('npd-pair-add');
    if (pairAdd) {
      document.querySelectorAll('#npd-pair [data-pg]').forEach(function (p) {
        p.addEventListener('click', function () {
          if (p.disabled) return;
          pairPick[p.dataset.pg] = p.dataset.v;
          syncPairPills();
        });
      });
      pairAdd.addEventListener('click', function () {
        if (pairAdd.disabled) return;
        var v = (D.vestVariants || []).find(function (x) { return x.color === pairPick.color && x.size === pairPick.size; });
        if (!v || !v.available) { showError(new Error('Choose an available color and size for the next vest.')); return; }
        var label = pairAdd.textContent;
        pairAdd.disabled = true; pairAdd.textContent = 'Adding…';
        addItems([{ id: v.id, quantity: 1 }],
                 [{ title: D.vestTitle, meta: v.color + ' / ' + v.size, img: (window.MitsiVariantImages || {})[v.id] || '', cents: v.cents, handle: D.vestHandle }])
          .catch(showError).finally(function () { pairAdd.disabled = false; pairAdd.textContent = label; syncPairPills(); });
      });
    }

    var leashAdd = el('npd-leash-add');
    if (leashAdd) {
      leashAdd.addEventListener('click', function () {
        if (leashAdd.disabled || !leashPick) return;
        var v = leashPick, label = leashAdd.textContent;
        leashAdd.disabled = true; leashAdd.textContent = 'Adding…';
        addItems([{ id: v.id, quantity: 1 }], [{ title: 'Reflective Leash', meta: v.color + ' / 6 ft', img: v.img, cents: v.cents, handle: D.leashHandle }])
          .catch(showError).finally(function () { leashAdd.disabled = false; leashAdd.textContent = label; });
      });
    }

    function collectPageMeta(form) {
      var t = document.querySelector('.pdp-buy h1');
      var img = document.getElementById('pdp-main');
      var color = document.getElementById('current-color');
      var size = document.getElementById('current-size');
      var vid = form.querySelector('[name="id"]').value;
      var v = (window.variants || []).find(function (x) { return String(x.id) === vid; });
      return { title: t ? t.textContent : 'Item',
               meta: (color ? color.textContent : '') + (size ? ' / ' + size.textContent : ''),
               img: img ? img.src : '', cents: v ? v.cents : 0, handle: v && v.handle ? v.handle : '' };
    }

    refresh().catch(showError);
    window.addEventListener('pageshow', function (event) { if (event.persisted) window.location.reload(); });
  });
  function showError(error) {
    var out = el('purchase-error');
    if (out) { out.textContent = error.message || 'We could not update your cart. Please try again.'; out.hidden = false; }
    var drawer = el('npd-error');
    if (drawer) { drawer.textContent = error.message || 'We could not update your cart. Please try again.'; drawer.hidden = false; }
  }
})();
